import script from "./index.vue?vue&type=script&setup=true&lang=ts&name=homePage"
export * from "./index.vue?vue&type=script&setup=true&lang=ts&name=homePage"

import "./index.vue?vue&type=style&index=0&id=0d712d61&scoped=true&lang=less"

import exportComponent from "/Users/user/Projects/simweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d712d61"]])

export default __exports__